import fetchLoyaltyAccountEligibility from 'actions/loyalty/fetchLoyaltyAccountEligibility'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

function useLoyaltyUserEligibilityTier(): [
  eligibilityTier: App.LoyaltyTier | undefined,
  eligibilityTierFetching: boolean,
  eligibilityTierError: any,
  ] {
  const dispatch = useAppDispatch()

  const loyaltyEligibility = useAppSelector(state => state.loyalty.eligibilityTier)

  useEffect(() => {
    dispatch(fetchLoyaltyAccountEligibility())
  }, [dispatch])

  return [
    loyaltyEligibility.data,
    !!loyaltyEligibility.fetching,
    loyaltyEligibility.error,
  ]
}

export default useLoyaltyUserEligibilityTier
